import { render, staticRenderFns } from "./Ckeditor.vue?vue&type=template&id=c7d68c84&scoped=true&"
import script from "./Ckeditor.vue?vue&type=script&lang=js&"
export * from "./Ckeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d68c84",
  null
  
)

export default component.exports